import { render, staticRenderFns } from "./SiderAdventure.vue?vue&type=template&id=0d20e6b4&scoped=true&"
import script from "./SiderAdventure.vue?vue&type=script&lang=js&"
export * from "./SiderAdventure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20e6b4",
  null
  
)

export default component.exports